export default defineNuxtRouteMiddleware(async (to, from) => {
	const { data, error } = await useFetch("/api/profiles", {
		headers: useRequestHeaders(["cookie"])
	});

	const user = await useSupabaseUser();

	if (!user) {
		return navigateTo("/login");
	}

	if (!data.value.is_admin) {
		return navigateTo("/");
	}
});
